export default __webpack_public_path__ + "static/media/8.1.05345992.jpg";